import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=27565020&scoped=true&"
import script from "./EditPassword.vue?vue&type=script&lang=ts&"
export * from "./EditPassword.vue?vue&type=script&lang=ts&"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=27565020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27565020",
  null
  
)

export default component.exports